import authFetch from './fetch';
import { getQueryParams, makeRequest } from './utils';

const baseUrl = '/api/RentalCompanies';

export const getRentalCompanies = (params) => makeRequest(authFetch.get(`${baseUrl}${getQueryParams(params)}`));

export const getRentalCompany = (id) => makeRequest(authFetch.get(`${baseUrl}/${id}`));

export const postRentalCompany = (data) => makeRequest(authFetch.put(baseUrl, data));

export const patchRentalCompany = (id) => makeRequest(authFetch.patch(`${baseUrl}/${id}/restore`));

export const deleteRentalCompany = (id) => makeRequest(authFetch.delete(`${baseUrl}/${id}`));

export const getRentalCompanyAudits = (id, params) => makeRequest(
  authFetch.get(`${baseUrl}/${id}/Audits${getQueryParams(params)}`),
);
export const getRentalCompanyAuditProperties = (id) => makeRequest(
  authFetch.get(`${baseUrl}/${id}/Audits/Properties`),
);
export const getRentalCompanyAuditUsers = (id) => makeRequest(
  authFetch.get(`${baseUrl}/${id}/Audits/Users`),
);